import billingPageReducer from 'BillingPage/Reducer';

export default {
  billingPage: billingPageReducer,
};
